module.exports = __webpack_public_path__ + "static/war-peace-1671b6608c632fa67e7f71782a31b513.jpg";